
// import { CollectionProxy } from 'spraypaint/lib-esm/proxies';
import { Component, Vue, Watch } from 'vue-property-decorator';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import markdown from 'spa-ionata-admin/lib/services/markdown';
import TitledSection from '../components/TitledSection.vue';
import BusinessTile from '../components/BusinessTile.vue';
import TradeMission, { TradeMissionProxy } from '../models/TradeMission';
import Business from '@/models/Business';

// interface ResponsePagination {
//   page: number;
//   pages: number;
//   count: number;
// }

@Component({ components: { TitledSection, BusinessTile } })
export default class extends Vue {
  dataPromise = new ObservedPromise<TradeMissionProxy>();

  page = 1;

  get slug(): string | undefined {
    return this.$route.params.slug;
  }

  get item(): TradeMission | undefined {
    return this.dataPromise.value?.data || undefined;
  }

  get error() {
    if (this.dataPromise.isError) {
      return this.dataPromise.error;
    }
    if (this.dataPromise.isFinished && !this.item) {
      let { slug } = this;
      if (!slug) {
        slug = '[blank]';
      }
      const maxLength = 50;
      if (slug.length > maxLength) {
        slug = `${slug.substring(0, maxLength)}…`;
      }
      return new Error(`TradeMission '${slug}' not found.`);
    }
    return undefined;
  }

  get intro(): string | undefined {
    if (!this.item?.locale) return undefined;
    const { introductoryText } = this.item.locale;
    return introductoryText
      ? markdown(introductoryText, {
          html: true,
          linkify: true,
          emptyLinesToBreaks: true,
        })
      : '';
  }

  get content(): string | undefined {
    if (!this.item?.locale) return undefined;
    const { content } = this.item.locale;
    return content
      ? markdown(content, {
          html: true,
          linkify: true,
          emptyLinesToBreaks: true,
        })
      : '';
  }

  get footer(): string | undefined {
    if (!this.item?.locale) return undefined;
    const { footerText } = this.item.locale;
    return footerText
      ? markdown(footerText, {
          html: true,
          linkify: true,
          emptyLinesToBreaks: true,
        })
      : '';
  }

  // get businessesPromise(): ObservedPromise<CollectionProxy<Business>> {
  //   if (!this.item?.exportMarkets) {
  //     return new ObservedPromise();
  //   }
  //   const { exportMarkets } = this.item;

  //   const promise = (async () => {
  //     const where: Hash<string | string[]> = { is_public: 'true' };
  //     where['export_markets.in'] = exportMarkets.map(item => item.id || '');
  //     return Business.where(where).page(this.page).per(20).all();
  //   })();
  //   return new ObservedPromise(promise);
  // }

  get businesses(): Business[] {
    // return this.businessesPromise.value?.data || [];
    return this.item?.businesses || [];
  }

  // get pagination(): ResponsePagination {
  //   const { page, pages, count } = (this.businessesPromise.value?.meta
  //     ?.pagination || {}) as ResponsePagination;
  //   return {
  //     page,
  //     pages,
  //     count,
  //   };
  // }

  get columns(): number {
    const { breakpoint } = this.$vuetify;
    if (breakpoint.lgAndUp) {
      return 4;
    }
    if (breakpoint.mdAndUp) {
      return 3;
    }
    if (breakpoint.smAndUp) {
      return 2;
    }
    return 2;
  }

  get rows() {
    const { columns, businesses } = this;
    const rows: Array<Business[]> = [];
    for (let n = 0; n < businesses.length / columns; n += 1) {
      const start = n * columns;
      rows.push(businesses.slice(start, start + columns));
    }
    return rows;
  }

  get linkToSearchInsteadOfExportMarkets() {
    return (this.item?.metadata || {}).linkToSearchInsteadOfExportMarkets;
  }

  get linkToSearchText() {
    return (this.item?.metadata || {}).linkToSearchText;
  }

  get overline() {
    return (this.item?.metadata || {}).overline;
  }

  @Watch('slug', { immediate: true })
  onSlugChanged(slug: string | undefined | null) {
    const promise = TradeMission.where({ slug })
      .includes(['exportMarkets', 'businesses'])
      .first();
    this.dataPromise = new ObservedPromise(promise);
  }
}
